import { Button, Dialog, DialogContent } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useAuth0 } from "../../../api/react-auth0-spa";
import EmailVerification from "./EmailVerification";
import LoginView from "./LoginView";

const Login = () => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const [emailVerification, setEmailVerification] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false); 

 useEffect(() => {
    const params = new URLSearchParams(window.location.search); // id=123
    // const error = params.get('error') // 123
    const error_description = params.get("error_description");
    if (error_description === "VERIFICATION_EMAIL_SENT") {
      console.log("HEre");
      setEmailVerification(true);
    }

    if (error_description === 'Access denied.') {
      setAccessDenied(true);
    }
  }, []);

  const onSignInClick = () =>
    loginWithRedirect({
      appState: { targetUrl: window.location.pathname },
    });
  const onSignupClick = () => loginWithRedirect({});

  if (isAuthenticated) return null;
  if (emailVerification) return <EmailVerification />;

  return ( 
    <div>
      <LoginView 
        onSignInClick={onSignInClick} 
        onSignupClick={onSignupClick} 
      />
      <Dialog open={accessDenied} onClose={() => setAccessDenied(!accessDenied)} fullWidth>
        <DialogContent>
          <div
            style={{
              textAlign: 'center',
              fontWeight: 600,
              fontSize: 20,
            }}
          >
            Please enter a work email ID
          </div>
        </DialogContent>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', marginBottom: '3%'}}>
          <Button 
            variant="contained"
            onClick={() => setAccessDenied(!accessDenied)}
          >
            OK
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default Login;
